// @mui
import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';
import { Box, Paper, Typography } from '@mui/material';
// utils
import { fData } from '../../utils/formatNumber';

// ----------------------------------------------------------------------

AudioRejectionFiles.propTypes = {
  fileRejections: PropTypes.array,
};

export default function AudioRejectionFiles({ fileRejections }) {
  return (
    <Paper
      variant="outlined"
      sx={{
        py: 1,
        px: 2,
        mt: 3,
        borderColor: 'error.light',
       
      }}
    >
      {fileRejections.map(({ file, errors }) => {
        const { path, size } = file;

        return (
          <Box key={path} sx={{ my: 1 }}>
            <Typography variant="subtitle2" noWrap>
              {path} - {fData(size)}
            </Typography>
            {errors.map((error) => (
              <Typography key={error.code} variant="caption" component="p" >
                - {error.code === 'file-too-large' ? 'File should be less than 20 MB.':error.message}
                {/* - {error.message && error.message === 'File is larger than 3000000 bytes' ? 'File is larger than 3 MB.':error.message} */}
              </Typography>
            ))}
          </Box>
        );
      })}
    </Paper>
  );
}
